import { useState, useEffect } from "react";
import { http, formatApiErrorDetail } from "../lib/api";

/** Sticky inline newsletter bar shown right under the masthead/ticker. */
export default function StickyNewsletterBar() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | done | error
  const [hidden, setHidden] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setHidden(localStorage.getItem("pr_sticky_hidden") === "1");
  }, []);

  const dismiss = () => {
    localStorage.setItem("pr_sticky_hidden", "1");
    setHidden(true);
  };

  const submit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    setError("");
    try {
      await http.post("/subscribe", { email: email.trim(), source: "sticky" });
      setStatus("done");
      setEmail("");
      setTimeout(dismiss, 2000);
    } catch (err) {
      setStatus("error");
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    }
  };

  if (hidden) return null;

  return (
    <div
      className="border-y border-ink bg-ink text-paper"
      data-testid="sticky-newsletter-bar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-2 flex flex-wrap items-center gap-x-4 gap-y-2 justify-between">
        <p className="font-mono text-[11px] uppercase tracking-[0.2em] flex items-baseline gap-2">
          <span className="inline-block w-1.5 h-1.5 bg-rojo rounded-full" />
          Recibe el briefing diario de POLÍTICA REAL
        </p>
        <form onSubmit={submit} className="flex flex-1 sm:flex-none items-center gap-2 min-w-0" data-testid="sticky-newsletter-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="tu@correo.com"
            disabled={status === "sending" || status === "done"}
            className="bg-transparent border border-paper/40 focus:border-paper outline-none px-3 py-1 font-mono text-[12px] rounded-none min-w-0 flex-1 sm:w-64 placeholder:text-paper/40"
            data-testid="sticky-newsletter-email"
          />
          <button
            type="submit"
            disabled={status === "sending" || status === "done"}
            className="border border-paper px-3 py-1 font-mono text-[11px] uppercase tracking-widest hover:bg-paper hover:text-ink transition-colors disabled:opacity-40 whitespace-nowrap"
            data-testid="sticky-newsletter-submit"
          >
            {status === "sending" ? "Enviando…" : status === "done" ? "✓ Listo" : "Suscribirme"}
          </button>
          <button
            type="button"
            onClick={dismiss}
            aria-label="Cerrar"
            className="font-mono text-paper/60 hover:text-paper text-lg leading-none px-1"
            data-testid="sticky-newsletter-dismiss"
          >
            ×
          </button>
        </form>
        {error && (
          <p className="w-full text-[11px] text-rojo font-mono mt-1">{error}</p>
        )}
      </div>
    </div>
  );
}
